import React, {Component, Fragment} from 'react';
import * as H from "history";
import {AssignmentsOverTime} from "../../models/analytics/AssignmentsOverTime";
import ApiService from "../ApiService";
import {SchoolOverviewResult} from "../../models/analytics/SchoolOverviewResult";
import {Doughnut} from "react-chartjs-2";
import AssignmentsOverTimeCard from "../AssignmentsOverTimeCard";

interface SchoolAnalyticsOverviewChartsProps {
    tenantId: string;
    schoolCode: string;

    startDate: string,
    endDate: string,
    academicYear: number,
    
    onAcademicYearChanged: (academicYear: number) => void;

    apiService: ApiService;
    history: H.History;
}

interface SchoolAnalyticsOverviewChartsState
{
    overviewResult?: SchoolOverviewResult;
    schoolAssignmentsOverTime?: AssignmentsOverTime;
}

export default class SchoolAnalyticsOverviewCharts extends Component<SchoolAnalyticsOverviewChartsProps, SchoolAnalyticsOverviewChartsState> {
    static displayName = SchoolAnalyticsOverviewCharts.name;

    constructor(props: SchoolAnalyticsOverviewChartsProps) {
        super(props);

        this.state = {
        };
    }
    
    
    private load = async () => {
        
        const overviewResult = await this.props.apiService.getSchoolAnalyticsOverviewResult(this.props.tenantId, this.props.schoolCode, this.props.startDate!, this.props.endDate, `${this.props.academicYear}`);
        const schoolAssignmentsOverTime = await this.props.apiService.getAssignmentsOverTimeForSchool(this.props.tenantId, this.props.schoolCode, this.props.startDate, this.props.endDate, this.props.academicYear);
        
        this.setState({
            overviewResult,
            schoolAssignmentsOverTime,
        });
    } 

    async componentDidMount(): Promise<void> {
        await this.load();
    }
    

    render(): JSX.Element | null {
        
        if(!this.state.overviewResult)
        {
            return null;
        }
        
        let doughnutChartData = {
            labels: [
                'Active Subjects',
                'Inactive Subjects',
            ],
            datasets: [{
                data: [this.state.overviewResult.activeSubjects, this.state.overviewResult.totalSubjects - this.state.overviewResult.activeSubjects],
                backgroundColor: [
                    '#99c140',
                    '#e7b416'
                ],
                hoverBackgroundColor: [
                    '#d0f261',
                    '#FFCE56',
                ]
            }]
        };
        
        return (
            <Fragment>

                <div className="flex-row flex--flow-wrap">
                    <div className="flex-column flex-item--flex-1">
                        <div className="card flex-row flex-item--flex-1 flex--align-items-center flex--justify-content-space-around">
                            <div className="number-stat">
                                <span className="number-stat__number number-stat__number--small">{this.state.overviewResult.activeAssignments || ''}</span>
                                <span className="number-stat__description">
                                    Active Assignments
                                </span>
                            </div>

                            <div className="number-stat">
                                <span className="number-stat__number number-stat__number--small">{this.state.overviewResult.totalAssignments || ''}</span>
                                <span className="number-stat__description">
                                    Total Assignments Set
                                </span>
                            </div>

                        </div>

                        <div className="card flex-row flex-item--flex-1 flex--align-items-center flex--justify-content-space-around">
                            <div className="number-stat">
                                <span className="number-stat__number number-stat__number--small">{`${this.state.overviewResult.percentageOfClassesWithAssignments.toFixed(2)}%` || ''}</span>
                                <span className="number-stat__description">
                                    Classes with Assignments
                                </span>
                            </div>
                            <div className="number-stat">
                                <span className="number-stat__number number-stat__number--small">{this.state.overviewResult.averageAssignmentsPerClass.toFixed(2) || ''}</span>
                                <span className="number-stat__description">
                                    Average assignments per class
                                </span>
                            </div>
                        </div>


                    </div>

                    <div className="flex-column flex-item--flex-1">
                        <div className="card card--padded flex-row  flex-item--grow-1">
                            <div className="flex-item--flex-1 flex-column flex--align-items-center flex--justify-content-center">
                                <span className="text-medium">{this.state.overviewResult.activeSubjects}</span>
                                <span className="text-smaller text-align-center">Subjects with active assignments</span>
                            </div>
                            <div className="doughnut-holder doughnut-holder--small doughnut-holder--centered flex-item--flex-1">
                                <Doughnut data={doughnutChartData} height={2} width={3} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"flex-row"}>
                    <AssignmentsOverTimeCard assignmentsOverTime={this.state.schoolAssignmentsOverTime!}/>
                </div>

            </Fragment>
        );
    }
}